import { render, staticRenderFns } from "./DayVideo.vue?vue&type=template&id=bd4366fe&scoped=true"
import script from "./DayVideo.vue?vue&type=script&lang=ts"
export * from "./DayVideo.vue?vue&type=script&lang=ts"
import style0 from "./DayVideo.vue?vue&type=style&index=0&id=bd4366fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4366fe",
  null
  
)

export default component.exports